module.exports = __webpack_public_path__ + "img/1618787159.f3bd30f5.png";